import { useEffect, useState } from 'react';
import Link, { LinkSizeText, LinkType } from '../Link';
import styles from './Error.module.scss';
import useTranslation from 'next-translate/useTranslation';

const Error = () => {
  const [mounted, setMounted] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className={styles.error}>
      <div>
        <div className={styles.content}>
          <h2>{t('error:title')}</h2>
          <p className="text_1">{t('error:text')}</p>
          <Link
            type={LinkType.WAVY_ARROW}
            href={'/'}
            textSize={LinkSizeText.MEDIUM}
          >
            {t('error:button-text')}
          </Link>
        </div>
        {mounted && (
          <iframe
            src="//open.spotify.com/embed/playlist/6XeAjOstSKLaMUcTAMvJHy"
            width="100%"
            height="380"
            frameBorder="0"
            allow="encrypted-media"
          ></iframe>
        )}
        <div className={styles.mobile}>
          <Link
            type={LinkType.WAVY_ARROW}
            href={'/'}
            textSize={LinkSizeText.SMALL}
          >
            {t('error:button-text')}
          </Link>
        </div>
      </div>
    </div>
  );
};
export default Error;
